import { Program } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getPrograms: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<Program[]> = (fetchContext, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/programs`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<Program[]>(fetchContext.errorStore, response, 'get programs'));
